import styled from 'styled-components'
import Button from 'shared/components/Button'
import { useState } from 'react'

import CheckoutPanel from 'checkout/components/CheckoutPanel'
import CreateAccountForm from 'login/components/CreateAccountForm'
import Divider from 'shared/components/Divider'
import LoginForm from 'login/components/LoginForm'
import UserSummary from 'checkout/components/AuthPanel/UserSummary'
import { CheckoutQA } from 'shared/dataAttributes'
import { ExpressCheckout } from 'checkout/panels/ExpressCheckout/ExpressCheckout'
import { fonts } from 'shared/lib'
import { media } from 'shared/lib'
import { t } from 'localization'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'

const TP = 'checkout.panels.GuestCheckoutAuthPanel'

type AuthForm = 'login' | 'createAccount'

export const GuestCheckoutAuthPanel = () => {
  const { continueAsGuest, createOrderRTK, updatePanel, userType } = useCheckoutContext()
  const [authForm, setAuthForm] = useState<AuthForm>('login')

  const handleClickAuthFormView = () => {
    setAuthForm(authForm === 'login' ? 'createAccount' : 'login')
  }

  const handleError = (errors: string) =>
    updatePanel('guestCheckoutAuth', { loading: false, error: errors?.[0] })

  return (
    <CheckoutPanel
      editable={false}
      expandedContent={
        <>
          <StyledButton
            $fill
            buttonType="secondary"
            data-qa={CheckoutQA.CheckoutAsGuestButton}
            onClick={continueAsGuest}
          >
            {t(`${TP}.checkoutAsGuest`, 'Check out as guest')}
          </StyledButton>
          <ExpressCheckout />
          <Divider />
          <Subtitle data-qa={CheckoutQA.DesktopCheckoutWithFlightClub}>
            {t(`${TP}.checkoutWithFCAccount`, 'Check out with your Flight Club account')}
          </Subtitle>
          <SubtitleMobile data-qa={CheckoutQA.MobileCheckoutWithFlightClub}>
            {t(`${TP}.checkoutWithFC`, 'Check out with Flight Club')}
          </SubtitleMobile>
          {authForm === 'login' && (
            <LoginForm
              createAccountInsteadStyle="linkAndDescription"
              onCreateAccountClick={handleClickAuthFormView}
              onLogin={createOrderRTK}
              onLoginError={handleError}
            />
          )}
          {authForm === 'createAccount' && (
            <CreateAccountForm
              location="during_checkout"
              loginInsteadStyle="linkAndDescription"
              onCreateAccount={createOrderRTK}
              onCreateAccountError={handleError}
              onLoginClick={handleClickAuthFormView}
            />
          )}
        </>
      }
      name="guestCheckoutAuth"
      qaAttr={CheckoutQA.LoginCreateAccount}
      summarizedContent={
        <>
          <UserSummary />
          <StyledExpressCheckout />
        </>
      }
      title={
        userType === 'loggedInUser'
          ? t(`${TP}.flightClubAccount`, 'Flight Club account')
          : t(`${TP}.account`, 'account')
      }
    />
  )
}

const Subtitle = styled.h2`
  display: none;
  ${media.medium`
    display: block;
    ${fonts.SUBTITLE_2}
    margin-bottom: 20px;
  `}
`
const SubtitleMobile = styled.h2`
  display: block;
  ${fonts.SUBTITLE_2}
  margin-bottom: 20px;
  ${media.medium`
    display: none;
  `}
`
const StyledButton = styled(Button)`
  margin: 20px 0 15px;
`
const StyledExpressCheckout = styled(ExpressCheckout)`
  margin-top: 20px;
`
